import { defineStore } from 'pinia'

export const useChooseAboNotificationModalStore = defineStore('chooseAboNotificationModalStore', {
    state: () => ({
        isOpen: false,
    }),
    getters: {},
    actions: {
        toggleModal() {
            this.isOpen = !this.isOpen
        },
    },
})
